<style lang="less" scoped>
  .card-slot {
    position: relative;
    &.empty {
      border: solid 4px #ffffff;
      border-radius: 15px;
      opacity: .6;
    }
  }
  .card {
    border-radius: 12.2px;
    border-radius: 20px;
    border: solid 5px #18a4ff;
    width: 100%;
    position: relative;
    z-index: 1;
    background-size: cover;
    background-position: center center;
    &:not(:nth-of-type(1)) {
      position: absolute;
      left: 40px;
      top: 0;
      z-index: 2;
      &:nth-of-type(3) {
        left: 80px;
        z-index: 3;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .overlay {
      width: 100%;
      height: 100%;
      background: #18a4ff;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
</style>

<template lang="pug">
  .card-slot(:class='{ empty: cards.length <= 0 }')
    .card(
      v-for='card in cards')
      .overlay(:style='{ opacity: overlay }')
      img(:src='card')
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    overlay: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    sortedData() {
      const data = [];
      Object.assign(data, this.data);
      // data.reverse();
      return data;
    },
    cards() {
      const result = [];
      for (let i = 0; i < this.sortedData.length; i += 1) {
        const shape = this.sortedData[i].shape;
        const card = this.sortedData[i].card;
        const url = `/static/cards/${shape}/${card}.png`;
        if (!shape || !card) {
          break;
        }
        result.push(url);
      }
      return result;
    },
  },
  methods: {
    loadCardImage(shape, card) {
      const url = `@/assets/cards/${shape}/${card}.png`;
      return url;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/card.vue